import classNames from 'classnames';
import './SubMatchCodeEdit.css';
import { ApIcon } from '@alixpartners/ui-components';
import { FocusEvent, useCallback, useMemo, useState } from 'react';

type BaseInputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export const SubMatchCodeEdit = (props: Omit<BaseInputProps, 'type'>) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const { className, onBlur, value, defaultValue, ...rest } = props;

  const blurHandler = useCallback((e: FocusEvent<HTMLInputElement, Element>) => {
    onBlur?.(e);
    setIsEditing(false);
  }, [onBlur, setIsEditing]);

  const iconName = useMemo(() => {
    if (isEditing) {
      return Number(value) !== defaultValue && value !== '' ? 'outline_check_circle_outline' : 'baseline_close';
    }
    return 'edit';
  }, [isEditing, value, defaultValue])

  return (
    <div className="claim-matches-grid--cell__submatch-cell flex-align-center">
      <input
        value={value}
        defaultValue={defaultValue}
        type={'text'}
        onFocus={() => setIsEditing(true)}
        onBlur={blurHandler}
        className={classNames('sub-match-code-edit', className)}
        {...rest}
      />
      <ApIcon iconName={iconName} iconSize={16} />
    </div>
  );
};
